import React from "react";
import { Link } from "react-router-dom";
import { CalendarIcon as Calendar } from "@phosphor-icons/react";
import { formatDate } from "@/lib/utils-app";

function DogEventRow({ reg, upcoming = false }) {
  const e = reg.event || {};
  return (
    <li className="flex items-start gap-4 py-2" data-testid={`dog-event-${reg.id}`}>
      <div className={`p-2 rounded-lg flex-shrink-0 ${upcoming ? "bg-[#C1272D]/10" : "bg-[#FAFAFA]"}`}>
        <Calendar size={20} weight="duotone" className={upcoming ? "text-[#C1272D]" : "text-[#6B6B6B]"} />
      </div>
      <div className="flex-1 min-w-0">
        <Link to={`/events/${reg.event_id}`} className="font-medium hover:underline">
          {e.title || "Event"}
        </Link>
        <div className="text-xs text-[#6B6B6B] mt-1">
          {formatDate(e.start_date)} · {e.location} · Handler: {reg.handler_name}
        </div>
      </div>
      <span
        className={`text-xs font-semibold rounded-full border px-3 py-1 ${
          reg.paid
            ? "bg-[#0E0E0E]/5 text-[#0E0E0E] border-[#0E0E0E]/20"
            : "bg-[#C1272D]/10 text-[#C1272D] border-[#C1272D]/20"
        }`}
      >
        {reg.paid ? "Paid" : "Plan"}
      </span>
    </li>
  );
}

export default function DogEvents({ events }) {
  const today = new Date().toISOString().slice(0, 10);
  const upcoming = events.filter((e) => (e.event?.start_date || "") >= today);
  const past = events.filter((e) => (e.event?.start_date || "") < today);

  if (events.length === 0) {
    return (
      <div className="bg-white border border-dashed border-[#E5E5E5] rounded-xl p-12 text-center">
        <Calendar size={40} weight="duotone" className="text-ink mx-auto mb-3" />
        <p className="text-[#6B6B6B]">No event entries yet for this dog.</p>
        <Link
          to="/events"
          className="inline-block mt-4 text-sm text-ink font-semibold hover:underline"
          data-testid="dog-browse-events-link"
        >
          Browse upcoming events →
        </Link>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {upcoming.length > 0 && (
        <div className="bg-white border border-[#E5E5E5] rounded-xl p-6 shadow-[0_8px_30px_rgba(0,0,0,0.04)]">
          <h3 className="font-spectral text-xl mb-4">Upcoming events</h3>
          <ul className="space-y-3">
            {upcoming.map((r) => (
              <DogEventRow key={r.id} reg={r} upcoming />
            ))}
          </ul>
        </div>
      )}
      {past.length > 0 && (
        <div className="bg-white border border-[#E5E5E5] rounded-xl p-6 shadow-[0_8px_30px_rgba(0,0,0,0.04)]">
          <h3 className="font-spectral text-xl mb-4">Past events</h3>
          <ul className="space-y-3">
            {past.map((r) => (
              <DogEventRow key={r.id} reg={r} />
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
